<template>
    <div id="emerge-landing-banner">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div id="emerge-banner" class="project-add-banner bg-color-mercury mb--50" data-sal="slide-up" data-sal-duration="1000" >
                    <div class="content">
                        <div class="row">
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <h2 class="black">
                                    Aumenta tus <span class="bold">ganancias</span>
                                    dando energía limpia
                                    a las 600,000 tienditas
                                    de <span class="bold">Coca-Cola FEMSA.</span>
                                </h2>
                                <button @click.stop="goToInvestorRegister()" class="axil-btn btn-borderd p-4 bg-emerge-red border-emerge-red">Empezar ahora</button>
                            </div>
                            <div class="col-sm-hidden col-md-4 col-4">
                                <!-- TODO -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "LandingBanner",
        data: () => ({
        }),
    }
</script>

<style>
#emerge-banner {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/emerge/banners/emerge-banner-01.png");
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #edeef0 !important;
}

@media (max-width: 750px){
    #emerge-banner {
        background-position: bottom;
    }
}

</style>